<template>
  <div class="pages">
    <img src="/static/service/banner@3x.png" class="tImg" />
    <div class="b_pic_text">
      {{ $t('main.catalogues') }}
    </div>
    <div class="content">
      <div>
        <div class="dis">
          <div v-for="item in lists" :key="item.id" class="other">
            <img v-if="item.thumb" :src="item.thumb" class="oImg" />
            <div v-else class="oImg pic_replace">{{ $t("main.nopic") }}</div>
            <div class="oBox">
              <div class="ointro">{{ $t("main.updateTime") }}:{{ item.release_time }}</div>
              <div class="otitle nowap">
                {{ item.title }}
              </div>
              <div class="oText">{{ item.size }}</div>
              <div class="facac">
                <div class="btn EDownloadForGoogle" @click="handleDownloadElectronic(item.download)">
                  {{ $t("main.EDownload") }}
                </div>
                <div class="btn" @click="handleDownloadPaper(item)">{{ $t("main.PaperRequest") }}
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="no-data" v-if="!lists.length">{{ $t('main.noData') }}</div>
      </div>
      <div>
        <el-pagination
          layout="prev, pager, next"
          hide-on-single-page
          :page="page"
          :page-size="limit"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getContents} from "@/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      cat_id: 0,
      page: 1,
      limit: 6,
      total: 20,
      lists: []
    }
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.init();
    },
    "$store.state.tabs": function() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))) {
        let tabs = this.treeToArray(JSON.parse(localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))));
        let catInfo = tabs.find(item => {
          return item.list_template == "category_productDirectory" && item.pid != '0';
        });
        if (catInfo) {
          this.cat_id = catInfo.id;
          this.getContentList();
        }
      }
    },
    getContentList() {
      let params = {
        req: {
          cat_id: this.cat_id,
          page: this.page,
          limit: this.limit,
          order: "orderby desc"
        }
      };
      getContents(params).then(res => {
        if (res.rsp.code === 0) {
          //console.log(res);
          this.lists = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      auxiliary(data);
      return res;
    },
    handleDownloadElectronic(data) {
      window.open(data, "_blank");
    },
    handleDownloadPaper(data) {
      this.$router.push({
        path: "/service/paperreq/" + data.cat_id + "/" + data.id
      });
    },
    handleSizeChange(val) {
      this.limit = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.init();
    },
    handleTime(v) {
      var chazhi = Cookies.get("Difference");
      var benditime = v*1000-chazhi;
      let date = new Date(benditime);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      let D = date.getDate();
      let H = date.getHours();
      let m = date.getMinutes();
      let s = date.getSeconds();
      return `${Y}-${M}-${D} ${H}:${m}:${s}`;
    }
  }
};
</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;

  .tImg {
    width: 100%;
  }
  .b_pic_text {
    position: relative;
    bottom: 9rem;
    margin: 0 auto -4.8rem;
    font-family: YouSheBiaoTiHei,serif;
    font-size: 3.5rem;
    font-weight: 400;
    text-align: center;
    font-style: italic;
    color: white;
    background-color: rgba(0,0,0,.5);
    border-radius: 0.5rem;
  }

  .content {
    .first {
      width: 100%;
      height: 31.25rem;
      margin-bottom: 1.875rem;

      .fImg {
        width: 100%;
        height: 18.75rem;
      }

      .box {
        width: 100%;
        height: 12.5rem;
        position: relative;
        background: #f2f2f2;
        margin-top: -4px;

        .bCont {
          color: #1a1a1a;
          margin: 1.25rem 3.125rem 0;
        }
      }
    }

    .fother {
      width: 100%;
      margin-bottom: 1.875rem;
    }

    .dis {
      margin: 0 -0.9375rem;

      .other {
        width: calc(100% / 3);
        display: inline-block;
        padding: 0 20px;
        margin-bottom: 2.5rem;
      }
    }

    .no-data {
      width: 100%;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border: 1px solid #f5f5f5;
    }

    .oImg {
      width: 100%;
      height: auto;
      border-radius: 0.5rem;
      // width:180rem;
      // height:241px;

    }

    .pic_replace {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #f2f2f2;
    }

    .oBox {
      width: 100%;
      // height: 241px;
      position: relative;
      background: #f2f2f2;
      text-align: center;
      padding: 5rem 1.875rem 2.5rem;
      color: #1a1a1a;
      margin-top: -4px;
      overflow: hidden;
      border-radius: 0.5rem;

      .facac{
        margin-top: 1rem;
      }
    }

    .ointro {
      background-image: url("/static/service/border_red.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 25rem;
      height: 1.875rem;
      text-align: center;
      line-height: 1.875rem;
      color: #635796;
      font-style: italic;
      position: absolute;
      top: 1.875rem;
      left: 0;
    }

    .otitle {
      font-size: 1.1428rem;
    }

    .oText {
      // padding: 1.875rem 0;
    }

    .btn {
      height: 2.25rem;
      border: 1px solid #1a1a1a;
      border-radius: 4px;
      padding: 0 1rem;
      line-height: 2.25rem;
      text-align: center;
      cursor: pointer;
    }

    .btn + .btn {
      margin-left: 1.875rem;
    }
  }
  @media screen and (max-width: 1400px) {
    .content {
      padding: 3.25rem 2%;
    }
  }
  @media screen and (min-width: 1400px) {
    .content {
      padding: 3.25rem 10%;
    }
  }
  @media screen and (min-width: 1700px) {
    .content {
      padding: 3.25rem 15%;
    }
  }

  .oBox:hover {
    background-color: #635796;
    color: #fff;

    .ointro {
      background-image: url("/static/service/border_w.png");
      color: #fff;
    }

    .btn {
      border: 1px solid #fff;
    }
  }

  .w33 {
    width: 33%;
  }

  .w67 {
    width: 67%;
  }

  /deep/ .el-pager li {
    background: #fff;
    margin: 0.1rem;
  }
  /deep/ .el-pagination {
    text-align: center;
  }
  /deep/ .el-pagination button:hover,.el-pagination button:focus,.el-pagination button:active {
    color: #635796;
  }
  /deep/ .el-pager li.active {
    background: #635796;
    color: #fff!important;
  }
  /deep/ .el-pager li:hover {
    background: #635796;
    color: #fff!important;
  }
}
</style>
